import ActivitiesSection from "../components/PageSections/KatalifeFree/ActivitiesSection";
import DownloadApp from "../components/DownloadApp";
import GrowthSection from "../components/PageSections/KatalifeFree/GrowthSection";
import ActivityProgressSection from "../components/PageSections/KatalifeFree/ActivityProgressSection";
import ShareFeedbackSection from "../components/PageSections/KatalifeFree/ShareFeedbackSection";
import KatalifeInfoSection from "../components/PageSections/KatalifeFree/KatalifeInfoSection";
import KataLifeFreePricingSection from "../components/PageSections/KatalifeFree/KataLifeFreePricingSection";

const KatalifeBasicPage = () => {
    return (
        <main>
            <KatalifeInfoSection />
            <ActivitiesSection />
            <ShareFeedbackSection />
            <GrowthSection />
            <ActivityProgressSection />
            <KataLifeFreePricingSection />
            <DownloadApp />
        </main>
    );
};

export default KatalifeBasicPage;
